import * as gs from "@ivanlog/gs";
import { CmpWidgetVXStatusBase } from "./tmpls";
import { Web3Helper as Web3UIHelper } from "../libs/Web3Helper";
import { BiMath } from "../libs/BiMath";
import { VControllerViewContract, VControllerViewResult } from "../contracts/VControllerViewContract";
import { ERC20Contract } from "../contracts/ERC20Contract";
import { VPoolContract } from "../contracts/VPoolContract";
import { VXContract } from "../contracts/VXContract";
import { App } from "../App";

export class CmpWidgetVXStatus extends CmpWidgetVXStatusBase {

    private _vxBalance:bigint = BiMath.Zero;
    private _vxInstWithdrawal:bigint = BiMath.Zero;
    constructor() {
        super();
        this.ctrls.lRate.text='-';
        this.ctrls.lYourStakePLS.text='-';
        this.ctrls.lTotalStakePLS.text='-';
        this.disable();
    }

    public get vxBalance(){return this._vxBalance;}
    public get vxInstWithdrawal(){return this._vxInstWithdrawal;}

    public async refreshAsync(vxData:VControllerViewResult, vx:VXContract, vpool:VPoolContract, vcontroller:VControllerViewContract, walletAddress:string)
    {
        const vxERC20 = new ERC20Contract(vx.address, App.chain.provider);
        const rate = BiMath.ToBI(vxData.vxRatio);
        const instWithdrawal = BiMath.ToBI(vxData.contedBalance);
        const totalSupply = await vxERC20.totalSupply();
        const totalWithdrawal = await vx.getTotalWithdrawalValueAsync();
        const validators = await vcontroller.getValidatorsCountAsync();
        const validatorsExiting = await vcontroller.getValidatorsToExitAsync();
        let totalStakePLS="-";
        if (totalSupply)
        {
            const totalSupplyUPLSBI = BiMath.ToBI(totalSupply);
            const totalStakePLSBI = totalSupplyUPLSBI*rate/BiMath.Decimal;
            totalStakePLS = Web3UIHelper.ToLargeNumberUnit(totalStakePLSBI, 5, "PLS");
        }

        let yourStakePLS:bigint;
        if (walletAddress)
        { 
            const withdrawalVX = await vx.getReserveOfAsync(walletAddress);
            const vxBalance = await vxERC20.balanceOf(walletAddress);
            this._vxBalance = BiMath.ToBI(vxBalance);

            const withdrawalVXBI = withdrawalVX?BiMath.ToBI(withdrawalVX.value):BiMath.Zero;
            const vxBalanceBI = vxBalance?BiMath.ToBI(vxBalance):BiMath.Zero;
            yourStakePLS = (vxBalanceBI+withdrawalVXBI)*rate/BiMath.Decimal;
        } 

        this._vxInstWithdrawal=instWithdrawal;
        this.enable();
        Web3UIHelper.ShortLabel(this.ctrls.lRate, rate, 5, "PLS/uPLS")
        Web3UIHelper.ShortLabel(this.ctrls.lInstWithdrawal, instWithdrawal, 3, "PLS")
        this.ctrls.lVXAddress.text = vx.address;
        this.ctrls.lVPoolAddress.text = vpool.address;
        this.ctrls.lValidators.text=validators!==undefined?validators:"-";
        this.ctrls.lValidatorsExiting.text=validatorsExiting!==undefined?validatorsExiting:"-";
        Web3UIHelper.ShortLabel(this.ctrls.lTotalWithdrawal, totalWithdrawal?BiMath.ToBI(totalWithdrawal):undefined, 3, "PLS");
        Web3UIHelper.ShortLabel(this.ctrls.lTotalStakeUPLS, totalSupply?BiMath.ToBI(totalSupply):undefined, 3 , "uPLS");
        this.ctrls.lTotalStakePLS.text = totalStakePLS;
        this.ctrls.lYourStakePLS.text = Web3UIHelper.ToLargeNumberUnit(yourStakePLS, 3, "PLS");
        this.ctrls.lYourStakeUPLS.text = Web3UIHelper.ToLargeNumberUnit(this._vxBalance, 3, "PLS");
    }
}